export default {
  productName: 'Console + 4 Trackers',
  description: 'Your training experience will be elevated with real-time performance data. The FightCamp Console stores and charges your 4 trackers, which slide into your quick wraps to unlock the full interactive experience. Every punch and kick is measured for speed, volume, and intensity — so you can track progress, push harder, and compete against your personal best.',
  shortDescription: 'Heart of FightCamp',
  isSoldOut: false,
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/1200x825/658f51c170/console-0001.jpg',
    alt: 'FightCamp console with trackers',
  },
  lifestyleImage: {
    src: 'https://a.storyblok.com/f/152150/352x352/213b19df90/fc-console-four-trackers-lifestyle-001.png',
    alt: 'FightCamp console with trackers',
  },
  includesModalCopy: {},
  assets: [
    {
      src: 'https://a.storyblok.com/f/152150/1200x825/658f51c170/console-0001.jpg',
      alt: 'FightCamp console with trackers',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1200x825/94fb2f768a/console-0003.jpg',
      alt: 'FightCamp console with trackers',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1200x825/176d6216bf/console-0002.jpg',
      alt: 'FightCamp console with trackers',
    },
  ],
  features: [
    {
      title: 'Features',
      copy: [
        'Console: Keeps trackers powered and organized',
        'HDMI Plug-and-Play Setup: Connects directly to your TV',
        'LED Lighting: Adds visual feedback',
        'Sleek, Compact, and Modern design to complement your home gym',
        '4 punch / kick trackers',
      ],
    },
    {
      title: 'Size & Fit',
      copy: [
        'Dimensions: 7.9” x 3.9” x 1.3”',
        'Console can be mounted on wall or sit on shelf',
      ],
    },
  ],
};
